import { ViewModel,View } from "binder"
import { IStaticValueProvider } from "../IStaticValueProvider";
import  { StringEditorView } from "./stringEditor-view"

export class StringEditorViewModel extends ViewModel implements IStaticValueProvider{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View <ViewModel> {
        return new StringEditorView();
    }
    public getTypeId(): string {
        return "VM-744CBBCD-642C-485B-A7C5-B7B1579225E9"
    }

    public set value(v: string) { this._value = v; } public get value(): string { return this._value;} private _value: string;

    setValue(v: string) {
        this.value = v;
    }
    getValue(): string {
        return this.value;
    }
    requestConfirm() {
    }

}
